import { NavItem } from '@nimmsta/ng-commons-lib/menu';
import { NavItemService } from '@nimmsta/ng-commons-lib/navigation';
import { map, Observable, of } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { ProfileService } from './profile.service';

@Injectable()
export class DevicesNavItemService implements NavItemService {
  private profileService = inject(ProfileService);


  getSidebarNavItems(): Observable<NavItem[]> {
    return this.profileService.getProfile().pipe(
      map((profile) => {
        const navItems = [
          new NavItem('dashboard', 'dashboard.nav', 'dashboard'),
          new NavItem('devices', 'devices.nav', 'devices'),
          new NavItem('reports', 'reports.defectReport.nav', 'lab_profile'),
          new NavItem('configurations', 'configurations.nav', 'manufacturing'),
          new NavItem('organizations', 'organizations.nav', 'groups'),
          new NavItem('users', 'user.nav', 'person'),
          new NavItem('access-requests', 'request-access.nav', 'concierge'),
          new NavItem('contents', 'contents.nav', 'person'),
        ];

        if (profile.isWeclappProcessingActive) {
          const batchItems = new NavItem('batch-items', 'batchItems.nav', 'web_stories');
          navItems.push(batchItems);
        }

        return navItems;
      }),
    );
  }

  getHeaderBarNavItems(): Observable<NavItem[]> {
    return of([]);
  }
}
